<script>
  import { _ } from "./i18n.js";
  import {
    Page,
    BlockTitle,
    Block,
    Icon,
    Row,
    Col,
    PhotoBrowser,
    Link
  } from "framework7-svelte";
  import Toolbar from "./Toolbar.svelte";

  export let f7router;

  let photos = [
    {
      html:
        '<video poster="https://lh3.googleusercontent.com/OOesaonm_p6-Pzx9GHOKpeOExevSoRqBTW4vw52X4teVTyChXVhr3WNA_WlvRhdt6heWXz5gUFRLY6if1NmCKr8uQJJC_exQV9011-LdR5dqYRUrUC5zE8IMHqZMd1rYJHykMEXMohTi3bqNCyKGTYfzcoCIce-3L07AGnX1RYk4tGx9jijzGVrIU__snYMq7oqwFxTOL6nsD3o7XuqB_6uk2SXgUCXihgPy5oTUYHKuxBe8IkQ5tLdoO0w31wVIq1JhZ0jYUuUyJa09gp5Tfq0N5r3lJDEVmWrdOC8uQNbdsK7gk2KpwRz-To6RG63GFrDkmqVX3rsmbeh-6pzZbcZHItlbQcvvVcjQ9-7pqUKj5K4zkSQ0ekkXtSqGnigCp2U7CLH64lMI8DNaVhxANczInU6PjCKgj2qq8QLH3fQZ0_aRumP3-1JgbzPCppclA28lRYL9t5LSJMThXpbBeyOS1lb3b2WfFdmr3KfIXLOJR-T8BmtPsz6yQJt8uNMhwyIEZFhZjQ0oih3032ubzZmkZY5cl5x2muKckvxQVhWm0g1vojAkucre3UbQVcRwc7bTi2T3ET5d9TQCQxfbKIiCPNWdPiTNM00-ztawwhNrTPaSwe9diw4qxlNwTgrtlBUs_3NSPaymtInNhGtbI9sRekzi0s-4aEMcUk-VS-rZHEC74P4rVfldPYwYQhJ0kJhMhkm8_uAVo8rf2QKTmZ7Ke19AD6PC5BW3B8saGJu6MWD2jPdJ-w=s1000" onloadstart="this.volume=0.1" width="100%" height="100%" controls autoplay><source src="/tle.mp4" type="video/mp4"></video>'
    },
    {
      url:
        "https://lh3.googleusercontent.com/IiMph1werBekH-bZkzphpxwxo2NUjgIyEYKOoPSM_FubPJXdKW8fKRyVDQtz2jL1Nsh-lJsvYKU8H8Zyakx8y_9TpeMDCP7Q7WKJOrG_1vEE8RrR7rgb0pe0qBpZFPDTOTw7H9QzJZEoBQpx8UqdZWiOixXlbGtx2XhSOD-fMx8NkN8cde-avef8MLEjIas0DKUq0ylUXbvmNcngzRbyKn4w0kPnrliqUOHOFxTghshWRZotDX0E10Vl-QPpm2kg4tbCXuQg5U8uoRN3v7bhF1rhEBbDigN1dK0fw8RyWb_SV10xMsNCDVy75W5o5UQWUp-eDebzIOQxFo3xy23PMRYLkmpykHRmKCdm3lkQEKT96agSliKfXarycbmKb6Y5MRz9PKad0RntL-5hhcsmnB0zrnP2WqWjeFMcVPXh6Grc5StLY6uGJs7lpeD3lA4JzqnFTm1v6xc_zB1owk7cPcAHmUATOt6k2IvsVecBaZ_ngvGKHu5kLXUDUSGIdFky772J4HEkDWwvjNH03wYkA3ET33ttUOGhq5Atefnm5NaAAkhSDc6JDMyLxzJ44EC1Nt3kbJPW2SYwYcQN3vUsv0uhukvEamx9YOLD38b_sRw0rvgHukOL_YsgZ28vdp4Sj9H24uOx-ArFooAfHOERQr3JJU-Kqg4h7FRKT8PieyxzCUxmB2nldfT3SwROeuDyX2j8ArZHNEqtUgPWDtciF4dKXyalNOPyDzMEWiixoRlzzwGOOuF-Zw=s1000"
    },
    {
      url:
        "https://lh3.googleusercontent.com/hetEt5Fd1awscnivczIEhf3S2vLK1kBmw3GxACtY59MMysU4Xhws3c6yLKtM1sZMtwhf4GMEPjDgorljkTDEvEqDLhGJhVVhM1sMJ-H5xpPs9KVqxT4ZCph92aEakw_JYuAEX98jw7uzdqWIqXKp22hhiXhJ0rZmFSia_zACpZOOS0jN6LYixq7BCi7gcIPlS08w6DumVqWtzizVmdn3Is2V3e-o7lXBTzfpX8STiV0jn5GTRZN1Yp0E47DiGbw6SdLr3KxE4JLZfA9y9T0s39LEsi027CCKftDE1Lc97-LZ1vAQfqvOKD81ROJKPG6fapAuStT0oblOiCneHL8vB9F2UrjGTliQXQFA3fz2a2JlJeCgJhpujXPtWsKjNIfXLO8aG55esM8LC7xkG-gXeGGQXQfJmgyMhtPoZy6HWvqdafsTMPfQmOckyUsAr-fA_k9i_8VGcilSrDaHFylT7Qf4sADkUb7VkRyV09iz9iFUsiHf5GkVkko1V03TVcjPul-CaPpw4GYGqzXudn5b9YCYglvd1Pt2P2Gm96WlnEkMzfjWpZKTla74oZHJzUTaUsfumsY0csTZxPWonA_nOQJmfKKnAPkon15AD73_P0anLSDREolHbX0CFtPpMDYYE7ymldOT5lFNnAGdX0QJrKRze3sXhy3UJr613c-W2pg_XdvtkiTTKqpPKI7x2HrXv87L4KXCKymTy_Uo5GKFZCOnPx7CjcoVbQH0hkndgY8a9DAmKaMwhQ=s1000"
    },
    {
      html:
        '<video poster="https://lh3.googleusercontent.com/sy7SegbDgRuo0YSKXePICbbIitxvMhdE3U1gffSkU-HA9kGD7Ds5BhK_DbJY1Hg25pSF4gkupXhQ8aN_ybHdSgFlk3c9sDUoRN0taCGgvWFk3cwN13h8sDE0LPnTJ6-dDhvLLnZry8VyUejyqpeKLEmaCq2w-XcBuf_-B0sna5kuajX4ZtHGyQf_p6ZWp1bK4UT73tmxm0WULAyZ0Mwcscj76qk_6p7AO3CmqFkoOD84LZqMfjtt04eIuSJpZVipqNUF59a3hRymrOHoeBYbVCCMU-njbXO31QKtJdEwUSrESTz7qY8yks8aAPNonrBOtN4bw_9oLLfhXbrKpZ-a9tW8_S6xaMpZHJ021FI_kHnpWfUZA1SCNjU3cguk63efbHhc1tHd-_PNZaZ2QEgsqNLEyUpdg_8gz_4-olA8Boqm-bsspgCGzEmPvpVoZlhZJawTWXSfgi-6qM5S8G_r2ytJlHqtjjKq_5S2tBPoE2-hU6qEKyFqDCtcdHvMNZlv7t2YPCMdTL3B42MjdoUKNI4tc7qkPZF-8VYZlbPn5IYxBO9vZdwKnPjqbYBgI2f8tA43QMlVkdFbdQfvELCyb8MHwSJlkR9V2qfrrBpDb-OJWAMvk8Cottbx0bW2VgPNpKuyk1sT4c_7kxAqHi3QXdsqlutFDgdpdR763ez7QR1Su4LZ3HIgxSsXmZbfewWWZCnyxGkw3dBuMDqD9sgZBa8TLgNcgREuK6JU7TxaCWGwTNGZu1V_xQ=s1000" onloadstart="this.volume=0.1" width="100%" height="100%" controls><source src="/wakeup.mp4" type="video/mp4"></video>'
    },
    {
      url:
        "https://lh3.googleusercontent.com/a0eSXr4F9yMIrVq_cm1m2VfbPWswC_JfZKXbylaFzvwoP9i_-f9G9U3NHznAnnbHExBsLgFCcPbIV1LNNob0Exj6mNYZbWe2yWMKGCWBu9LJ3DHn1wSHU9sd11cCkSNsyGUGL3VWAoS7bZyp3Dzl0fKncjKl_PV8z75xWHw5tW_SCKWS2NxAQ4Qujbe-cdhSWdzWiSLm2jIQcme_zeGkempKjW2t6rCWAXp49XuLs_C1skNpSVO2yjaE63o7UgBQ7ns7v3z8_cxtiRzqzsR6u0FoOTu7GtQvQPySW5mxaYxw3ZhwzM1LPBfc-dKCJ-lGR6upUvqjTCfk-NabQTKguVJzIZoYk5zDMa6yYE7WJDcCW9il5c7nQAEHE9R0MjaG7YgarziDPqM_PCjdyp7mtcd3mMesyunspt6VY0QsP-vcIIRgAUHI_ebJ8kLGL4dZ5iYn7tUkXV_k3LXtjQkaLRdqLWkeLpKM1LzkDzlWYmdNhMDr3yGtAWDcXKW08_MGLJ313hYjW3-RoqRuxjmIHXW-vf_sTDzWp5ozS8C1gCHbOkoDdTM6MdVyICyxaTOBLz9mv_Mw1LwO8ivCphIqdwbGuuDLylu2dLxUfmx0Poo-qfOyu4CPeeUDoNjC7H1UKLTh4oMRdKEWJ-22pSDCRi346eSd8ydzNxhFP1j0L4YS_06k9-A3Bhacrzogr4cFXQS5K9WfZVZBQYa6Sygu5NL6p-krGJkKUzHpy23J5-bPr50d_hgQ7Q=s1000"
    },
    {
      url:
        "https://lh3.googleusercontent.com/496DOH3jdX_Q3sKLYBreQJT2sLLL6TKIaDVgXEY-xqilDgqiqBTgHqgMHQlp4UG1w_vtQuQHjZ97geIl6qbBUYlkhxXEq88q19DBOTsQqPjlt-rKsTf2ZdIEutPkLpWMEFVV3ZKnpidTJ0G9SPnFxZ1UMRg-qEGBmy36YomwY1l30IzALV7zD1-jbu0x2Zxrh_Ix3bmDrznPQVIALKku88C-zhf19fpn0AORUAHJ7Lc66TaxJEMgEbThOk3jeKpgC7cpQCA18H5zIALIhn8uG3xs9KJ_Uzm305kKVguxFTk5bej1FIvs3H9S5uKSG93MnwdPzVPLE4Obpe1TLTk8_zs5UGCRRIp2Wg36eKjE5ngg0AeZuBwXMlGiZ-URHCFkMVHhedMyiDMSfQ9hiU6qrPq3wmnH_5F740gZ3KuwSpZ1lQ1028Lx5jvujpui1jqKbmnjr16brbj_seNxBlRuOIEmfeyIkPA6TScLNxUl6TYgg3m4kl8WkjcvkYqkUTitQ_4ImzpCKAL7s3jjO79JDhNLvOy2h0GC0Fz-rbjQZ0gY0yBPAGKhJRC7d1MCmdFo79SyvD30s6NzJ5UdOLP6k72MqaYG7ezjjqhbZYZgZu7hOb4E9Pmlg8zz3zd7bPYvjXIn70tTUX6q13FX1y-X4nc6mGsk8CfIGzrquaHIb1C-FMv_sd9QAbeh_vE7kUb8lMeM420fp3rQSJFyoA7_9eVt4_kfNanqwL9OOluLLeb8LOmr0BdSMA=s1000"
    },
    {
      html:
        '<video poster="https://lh3.googleusercontent.com/jg4feI6iSf7w-OEMEkNLa8K2ATB5RD-M3SSvNBu9m4SbTO4g7IqyuYSIGsaA7VFdkN0xrv16GgFXYv083JwPqWPEa2lVz_1eA_Jcmvf2Phmlziq2uL4LWmgtqKL6Ylqx5zRgZjZ8MUQG5wpOGosMrZLljkln0lLu2L8s7ETN64-67h67sQaWXNeVJ5_0wXPp1ckp-WFnSqtY9he4QqQ8Dwfh8-1nSR7xxKh9fwuB6RiD1bjMN3SW32krZnuK2GUboX4m_mOSsbCrJasqKtDG74kc9WNteRLx63xpOIlScicL1YKbl9vopQIjlT0bQqT2wRCOW4DIgzPmuM-i3d876FF1SSJoKTnysgYo8ynuiYn84Q3IxEjevKvxtX1KR8kgo7JfhJuaXdSjFo0UwWs_Gj5WaYWj2cWva1L8X6RH3pAdpHI-5MYYSD1Nu_lcL5wguo_jTa3b5yw5gJjhTtM09ke88DnYQuerX2AfrvdHwgtT16mCyHTgdjHWJ1oGJtSVp9AjeQNycp0WsTZ_JcofEVLwvkQWmguqy3zR9QSBBMGyopigq5Uji-ZoSFtFWNSmZpev59G6CV-6Vc1YYitErIxeF6glPSnlT7oIUhC1Q8QyXd6I1B6wIqv6RAoqSWnoly69aPmRJPWHz4CWmMWv1quss8JT4Lr06xjPIcHx-yaezpRM3lV2r8KIoh8Uk72xSdaJE31g_2cMGJAx0r96C_uehWuafy9l9nw7x79SBa4n-S30GhDdmw=s1000" onloadstart="this.volume=0.1" width="100%" height="100%" controls><source src="/fridge.mp4" type="video/mp4"></video>'
    },
    {
      url:
        "https://lh3.googleusercontent.com/7MrdE327fkJbFFKuUFX8gV42h3MihJ7TAank2UPomuR3WhAGyPQ_pA29MgmM9ahOhOkOGrJf_CuPUn_S1oya1CywAsUVAZvH7_Sg5IWBNZ0Jhk8Z9GZEHIWGJie0pM1jz760V1vJFnBga8f8U1vr6XwZkDHwg9Qi4L1wBt5jiE4hkGOaZlJPfEddIfDjB-L95QnDlg4ph4FO-HeFpWO0y1Z_d4Jc0PrPB2J3qgLuF153e3ZLHyAHkv7hhTIS9qq_qFTC9pHEo1kZiSjzcMap-R_u9pFR3T71foP0-QNHIDIDuDsRom5JZl9iQM3CfxNA0cPn6uv6hAS35h_A2Vo6EQPUujFRpVwHVutKjVt1BW20uuUxp-F459WaN-wDOk7-F1jgs4J9QTWBuqL4NybjwvdPSIFPfcpcieenALyYVJY21Nx-CEwFzZPuzXGuWrXtomHH5hiyBaKpSknvFydch9d2SW90b2RyKTJu0O0JtKZOfkxUfo-GD9NDfDB6jBprRDMU9HwNIMjCLXQWQqd52h0NxfMnFlhBTyEuQJcJzBSGHaLoEEjO03zJXgOI6L9NlT6Pa7Tywe1lddoMOEEVmixLIAzK_TS3AMqMAB8ptDSNOfnaFrpwRD5khKLQA_vMxbOwTt9XsKkFsqU0wgxwG5KFd1velm_xJRT8kkNLT3y5tUyGzI7kZuOKetqZvVKdCuFfGx5KDxMAC5n8jlfLOqy6SO3jovDueUG8QUdZhKUUat-rwrf5lA=w1478-h1108-no?authuser=1"
    },
    {
      url:
        "https://lh3.googleusercontent.com/1p-5FtJwIHBXaFOjdPFHVh79l_ndi-KcqZpbvIUaTMtOchMlX79tFmzxI3j3ntZEAtHNK6p6B1kG4pualabLXN7bOGOdwKR9iVTZnT0LIdH-dZ3D6PjlAXojm0J60GRR8O1Pw1MW6BhETPXFSi-t-r28Tyw5t80z6-hu1m1bSW7u4NzS7p9b3Z1W8Jb3Do9Js2cuho3-PMGrGUUn114PimyNmr1_W1Z8vxE7wsLUokG4JG8hlWugT4PNlVDObDNNTHQopnSSyg9dJHgFn9ilnIy0kqWOlk0N_UkXIEV8tGQrQncpuWftWDUcJp4WgG2pA34WQWhBwZwmTGt7NXqAfXfJlHOz9qsCzbHdlZlN5VoRjhTfVx1bBhbdpOEirGAHEn_8qy5b3igMdmcBC1dzsCNTc-XwN10mey-XGo_JvFxK03i2I357HuvoGkg1shMgvwPMypM0PHB3co2yZfdfEkABWzcZOMuaDOrqQsEd9fi8MvdwOvO3MPVaVDUvWG6_5RA5fyRYDSQ4hLl8pQpiMEmUR60Wg3cQD1KLXSVlF_M_GIzpRZcSO-N-nqFAUVhsOKh32mXbkRzZx1ymeuEvpnEN3MAgCOqGQVamavob2Tn4Scduxdn6-OwrmSdya8w1yQhdvaVwDBFepFBv4b8gmINmPbMwpSf0c9iIVcZU8Iybs0KOsJrGsDIL3v-rNcnbuNjvk7sBDJpdkuXZu3CuBx1Ln0e-htV14RrEmXxXabtClZYuWs6mPA=s1000"
    }
  ];
  let photoBrowser;
</script>

<style>
  :global(.home div[class*="row"]) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  :global(.home div[class*="col"]) {
    color: white;
    font-weight: bold;
    padding: 1.5rem;
    cursor: pointer;
    border-radius: 4px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  :global(.home div[class*="col"] i) {
    font-size: 3rem;
    margin-top: 15px;
  }
</style>

<Page class="home">
  <div class="page-content">
    <Block>
      <BlockTitle medium>{$_('home.title')}</BlockTitle>

      <div>
        <p>{$_('home.description')}</p>
      </div>

      <Row style="margin-bottom: 0px; padding-bottom: 0px">
        <Col
          on:click={f7router.navigate('/Products/')}
          style="padding: 0px; margin-bottom: 0px; font-size: 2rem;">
          <img
            style="width: 100%; border-radius: 4px;"
            alt="Tueyhom Products"
            src="https://lh3.googleusercontent.com/6xzeLvRFsnt6jIUkWQvQETq28wGvVaUUdAe15Vj2V45-LaDNI123FYuQuoBt1eibkoGZ7Mh-o_NI_Jds1uP1TnKK1fmOowJ7cA7eEsBHSC6XJgU9X_7ZVHMdK-lq5AzQhR50D1u8SgfqHAtSNFgZQM5ICHse667oTyn3HDV9hgiPByzwE7Np-1rDNDW75SWJGJ7g8SAeg2zB5B4kSmjxpShZ8YvqMw4XlxjTVi8zCGx0HPkBnqLfE-l__e_icOZE5YOL_5dd0MaIMwe7yJdG1yFgnvbbUc7r50anYrMtt-iaNDfIU-h6wP7pPJNnUJuaE5e0tidnSkiN09D1dqNjb7kh3QxZ5zQUxuVti8FT4jFHjF5lkAP8cFTdvntVKU0mNp74K40MTiNE2mQUCeusggl1y2kpmPB3OYHpaq7jOqPDdAUjy8PcnbeYSoHnW6fpaubr-KvWdmhe08R8R_A9lIITK9FJLNnAmlMK6nRvkOCZ0L6eosJL3gRGxpmMdxKdehjuYqkv7REdj4A9CLGlHS31bA0B6UNstZHVAantMWBSsrjhGHQwoEhxy5FqcZZVl5fQKbO9QISFPDaG60Hmu2FPoB_mIfeDWAhLiZKAIq7SBlglhigRYpZaqHtlzqQGegH69oBtVRDx2-Lec-sVN4maC2wDjGuBvK-doj065DHTkcjHFAErVOiJg8Dk1_S9GyUblDpJ4g9ceS4gyAo0YlZI0TbSwKzo4FVLev1XBVdMzU89bg2ReA=s1000" />
        </Col>
      </Row>
      <Row>
        <Col
          on:click={f7router.navigate('/Products/Tueyhom')}
          style="background-color: #0080e4; font-size: 1.5rem">
          <div>{$_('home.tueyhom')}</div>
          <div>
            <Icon icon="icon-bottle" />
          </div>
        </Col>
        <Col
          on:click={f7router.navigate('/Products/Fuji')}
          style="background-color: #eb72a8; font-size: 1.5rem">
          <div>{$_('home.fuji')}</div>
          <div>
            <Icon icon="icon-bottle" />
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          on:click={f7router.navigate('/About')}
          style="background-color: rgb(8, 98, 160); font-size: 1.5rem">
          <div>{$_('home.aboutUs')}</div>
          <div>
            <Icon icon="icon-question" />
          </div>
        </Col>
        <Col
          on:click={f7router.navigate('/Cart')}
          style="background-color: rgb(29, 78, 124); font-size: 1.5rem">
          <div>{$_('home.shopNow')}</div>
          <div>
            <Icon icon="icon-cart" />
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          on:click={f7router.navigate('/Order/New')}
          style="background-color: rgb(43, 75, 100); font-size: 1.5rem">
          <div>{$_('home.orderEasily')}</div>
          <div>
            <Icon icon="icon-truck" />
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          onClick={() => photoBrowser.open()}
          style="padding: 0px; font-size: 1.5rem;">
          <div>
            <div
              style="margin-top: 10px; margin-bottom: 10px; color: rgb(0, 122,
              255)">
              Gallery
            </div>
            <img
              style="width: 100%; border-radius: 4px;"
              alt="Gallery"
              src="https://lh3.googleusercontent.com/G9E36Xch_kkrrREdMoqOW1VPSphbYqj4VlykVRv5SvcJpkCGNyqOB7xJH0i3uBLHhzTSshZxOYeBC784PRVkkG0cjxolrNRlhfwmt0TTds-SdXtwbDzdznOFBUimFPJI9Ev8uAK0JqYtPTthZMLCMFExXA1LNfertzqDZrsHt3N4ICnBS1AaC7g2rcmOrVOXjARG16CSHAM8R3TqHRIyvpe1GKc75F_HzK3sQxKCRxMtvx2G4gvyQOEVdlCu8GGaM8WLVzfrZVJic_7PMdcvg6JA78WxKxuxqvZxsiAKQvnz-UO6toVU3gBvknzymeCdWJyLcprSubGh1smABrncDtjzcasOCS_eV_2aeKc7B5opaqBhgrOBT9c33x63xsfwUCMvMibjq2j-5hY4wdxnRQv8FGl9y0sJZX_UkLuMASa0VxrlZzzb-2mKKHQfHudliUWnt9Z3oITt7t_eVpQ3Ka2U-x7jQ2sha2oui0jdXnrHjCWUPaPHsLBg9rRGwtqf9ytMCdC5qLGJkPvtdRt8beGFhVbCvltnJS417cdtSLSlk7csZ9KljrdMp-GtsqHf1BB7wjoFydvL1PBC7at78v4kdxDHNEOakZSb9cVI2M9kgiZaiYS9ZjmyyblGnWwr2Zkw3JPeeqiCvJDcmZ7ZaodrzdngVtH-hEF7SA6rNEEWrKmUrzXgLFwXiaUuiOZQ0E3aygMZbEjiMFMVaVJXGYkDNqJ-D_3Sq5L7O1YlV7zscuvf5BuoFg=s1000" />
            <PhotoBrowser
              routableModals={false}
              theme="dark"
              {photos}
              bind:this={photoBrowser}
              popupCloseLinkText={$_('base.close')}
              navbarOfText={$_('base.of')} />
          </div>
        </Col>
      </Row>
    </Block>

    <div
      style="color: rgb(0, 122, 255); text-align: center; margin-bottom: 30px;">
      <div>
        {$_('about.copyright', { values: { year: new Date().getFullYear() } })}
      </div>
      <div>
        <Link style="text-decoration: underline" href="/Terms">
          {$_('terms.title')}
        </Link>
      </div>
    </div>
  </div>

  <Toolbar tabLinkActive={'/Home'} />
</Page>
